export default {
    '.adyen-checkout__payment-method--affirm .adyen-checkout__field--country': {
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },

    '.payment-methods-stack[data-is-charitable-donation="true"] .adyen-checkout__payment-method--klarna':
        {
            cursor: 'not-allowed',
            pointerEvents: 'none',
            bg: 'gray.300'
        },

    '.payment-methods-stack[data-is-charitable-donation="true"] .adyen-checkout__payment-method--klarna_account':
        {
            cursor: 'not-allowed',
            pointerEvents: 'none',
            bg: 'gray.300'
        },

    '.payment-methods-stack[data-is-charitable-donation="true"] .adyen-checkout__payment-method--afterpaytouch_US':
        {
            cursor: 'not-allowed',
            pointerEvents: 'none',
            bg: 'gray.300'
        },

    '.payment-methods-stack[data-is-charitable-donation="true"] .adyen-checkout__payment-method--cashapp':
        {
            cursor: 'not-allowed',
            pointerEvents: 'none',
            bg: 'gray.300'
        },

    '.payment-methods-stack[data-is-charitable-donation="true"] .adyen-checkout__payment-method--affirm':
        {
            cursor: 'not-allowed',
            pointerEvents: 'none',
            bg: 'gray.300'
        },

    '.payment-methods-stack[data-is-egift-only="true"] .adyen-checkout__payment-method--klarna': {
        display: 'none'
    },

    '.payment-methods-stack[data-is-egift-only="true"] .adyen-checkout__payment-method--klarna_account':
        {
            display: 'none'
        },

    '.payment-methods-stack[data-is-egift-only="true"] .adyen-checkout__payment-method--afterpaytouch_US':
        {
            display: 'none'
        },

    '.payment-methods-stack[data-is-egift-only="true"] .adyen-checkout__payment-method--cashapp': {
        display: 'none'
    },

    '.checkout-container-box[data-is-employee="true"] .adyen-checkout__payment-method--klarna': {
        display: 'none'
    },

    '.checkout-container-box[data-is-employee="true"] .adyen-checkout__payment-method--klarna_account':
        {
            display: 'none'
        },

    '.checkout-container-box[data-is-employee="true"] .adyen-checkout__payment-method--affirm': {
        display: 'none'
    },

    '.checkout-container-box[data-is-employee="true"] .adyen-checkout__payment-method--paypal': {
        display: 'none'
    },

    '.adyen-checkout__payment-method--credit .adyen-checkout__button--pay': {
        display: 'none !important'
    },

    '.adyen-checkout__card__form--oneClick': {
        marginBottom: '16px'
    }
}
